import axios from "axios";

let input = {
    fillSelect: function (selector, input, data, sort = false) {
        let config = selector.config;
        selector.havingAttribute(config.dynamic, input).forEach(function (item) {
            item.remove();
        })
        let collection = new Array();
        for (var property in data) {
            if (data.hasOwnProperty(property)) {
                collection.push({
                    id: property,
                    value: data[property]
                })
            }
        }
        if (sort) {
            collection.sort(function (a, b) {
                if (a.value < b.value) {
                    return -1;
                }
                if (a.value > b.value) {
                    return 1;
                }
                return 0;
            });
        }
        for (let i=0; i<collection.length; i++){
            var option = document.createElement("option");
            option.text = collection[i].value;
            option.value = collection[i].id;
            option.setAttribute(config.dynamic, '');
            input.add(option);
        }
        input.dispatchEvent(new Event('filled'));
    },

    fetchCounties: function (county, config) {
        let that = this;
        let _selector = selector(config);
        api(config).getCounties().then(function (data) {
            that.fillSelect(_selector, county, data);
        });
    },

    updateLocalities: function (county, config, container, target) {
        let that = this;
        let _selector = selector(config);
        let locality = _selector.havingName(target, container)[0];
        _selector.havingAttribute('data-csr-dynamic', locality).forEach(function (item) {
            item.remove();
        })
        api(config).getLocalities(county.value).then(function (data) {
            that.fillSelect(_selector, locality, data, true);
        });
    },
    updateBrands: function (config, container) {
        let that = this;
        let _selector = selector(config);

        let type = _selector.havingName('tip_inmatriculare', container)[0].value;
        let category = _selector.havingName('categorie', container)[0].value;
        let subCategory = _selector.havingName('subcategorie', container)[0].value;
        let input = _selector.havingName('marca', container)[0];
        api(config).getBrands(type, category, subCategory).then(function (data) {
            that.fillSelect(_selector, input, data);
        });
    },
    updateSubcategory: function (config, container) {
        let that = this;
        let _selector = selector(config);
        let category = _selector.havingName('categorie', container)[0].value;
        let input = _selector.havingName('subcategorie', container)[0];
        api(config).getSubcategories(category).then(function (data) {
            that.fillSelect(_selector, input, data, true);
            let selectedSubcategory = window.localStorage.getItem('trans-subcategory');
            if(selectedSubcategory) {
                that.setSelectedForSelect('subcategorie', selectedSubcategory);
            }
        })

    },
    updateModels: function (config, container) {
        let that = this;
        let _selector = selector(config);
        let brand = _selector.havingName('marca', container)[0].value;
        let input = _selector.havingName('model', container)[0];
        api(config).getModels(brand).then(function (data) {
            // console.log(data);
            // that.fillSelect(_selector, input, data);
        });
    },
    setSelectedForSelect: function (selectName, selectValue) {
        let select = document.querySelector("[name='" + selectName + "']");
        for (var i = 0;i < select.childNodes.length; i++) {
            if(select.childNodes[i].value == selectValue) {
                select.childNodes[i].setAttribute('selected', 'selected');
                select.dispatchEvent(new Event('change'));
                break;
            }
        }
    }

};
let api = function (config) {
    return {

        httpValidationCode: 422,

        isValidationError(e) {
            return e.response.status == this.httpValidationCode;
        },

        async submit(payload) {
            const response = await axios.post(config.api.forms.submit, payload);
            return response.data;
        },
        async getCounties() {
            const response = await axios.get(config.api.forms.utility + '/county');
            return response.data;
        },
        async getLocalities(countyId) {
            const response = await axios.get(config.api.forms.utility + '/locality', {
                params: {
                    'county_id': countyId
                }
            });
            return response.data;
        },
        async getBrands(registration, category, subcategory) {
            const response = await axios.get(config.api.forms.utility + '/brands', {
                params: {
                    'registration': registration,
                    'category': category,
                    'subcategory': subcategory,
                }
            });
            return response.data;
        },
        async getSubcategories(category) {
            const response = await axios.get(config.api.forms.utility + '/subcategories', {
                params: {
                    'category': category,
                }
            });
            return response.data;
        },
        async getModels(brand) {
            const response = await axios.get(config.api.forms.utility + '/models', {
                params: {
                    'brand': brand,
                }
            });
            return response.data;
        }
    }
}

let initialize = {
    "leasing_state_id": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'leasing_locality');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },
    "state_id": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_1": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_1');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_2": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_2');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_3": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_3');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_4": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_4');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_5": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_5');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_6": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_6');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_7": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_7');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_8": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_8');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "state_id_9": function (element, container, config) {
        element.addEventListener('change', function (e) {
            input.updateLocalities(e.target, config, container, 'locality_9');
        });
        if (!element.hasAttribute(config.fetched)) {
            input.fetchCounties(element, config);
        }
    },

    "tip_inmatriculare": function (element, container, config) {
        element.addEventListener('change', function () {
            input.updateBrands(config, container);
        });
    },
    "categorie": function (element, container, config) {
        element.addEventListener('change', function () {
            input.updateSubcategory(config, container);
            input.updateBrands(config, container);
        });
    },
    "subcategorie": function (element, container, config) {
        element.addEventListener('change', function () {
            input.updateBrands(config, container);
        });
    }
}

let config = function (options) {
    let merge = function (target, source) {
        for (const key of Object.keys(source)) {
            if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]))
        }
        Object.assign(target || {}, source)
        return target;
    }
    let prefix = function (name) {
        let prefix = data.prefix;
        return name.length > 0 ? prefix + "-" + name : prefix;
    }
    let creating = function (input, container) {
        if ('undefined' != typeof initialize[input.getAttribute('name')]) {
            initialize[input.getAttribute('name')](input, container, this);
        }
    }

    let data = {
        prefix: 'data-csr',
        errors: {
            placeholder: "!!message!!",
            all:false
        },
        api: {
            forms: {
                submit: '/csr/submit',
                exception: function (e) {
                    console.error(e);
                }
            },
        }
    };

    merge(data, options);


    return merge(data, {
        container: prefix('container'),
        input: prefix(''),
        error: prefix('error'),
        messages: prefix('error-messages'),
        message: prefix('error-message'),
        hasErrors: prefix('has-errors'),
        success: prefix('success'),
        related: prefix('related'),
        blur: prefix('on-blur'),
        template: prefix('template'),
        fetched: prefix('fetched'),
        dynamic: prefix('dynamic'),
        creating: creating
    });

}

let selector = function (config) {

    return {

        config: config,

        havingName: function (name, container) {
            let str = '[name="' + name + '"]';
            return container.querySelectorAll(str);
        },
        havingRelated: function (name, container) {
            let str = '[' + config.related + '="' + name + '"]';
            return container.querySelectorAll(str);

        },
        havingSubmitOnBlur: function (container) {
            let str = '[' + config.blur + ']';
            return container.querySelectorAll(str);
        },
        formItems: function (container) {
            let str = '[' + config.input + ']';
            return container.querySelectorAll(str);
        },
        havingErrorClassesFor(name, container) {
            let str = '[' + config.related + '="' + name + '"][' + config.error + ']';
            return container.querySelectorAll(str);
        },
        havingErrorMessagesFor(name, container) {
            let str = '[' + config.related + '="' + name + '"][' + config.messages + ']';
            return container.querySelectorAll(str);
        },
        errorMessagesFor(name, container) {
            let str = '[' + config.message + '="' + name + '"]';
            return container.querySelectorAll(str);
        },
        containers() {
            return document.querySelectorAll('[' + config.container + ']');
        },
        havingAttribute(name, container) {
            let str = '[' + name + ']';
            return container.querySelectorAll(str);
        },
        havingAttributeValue(name, value, container) {
            let str = '[' + name + '="' + value + '"]';
            return container.querySelectorAll(str);
        }
    }
}

let error = function (container, selector) {

    let addErrorClasses = function (name) {
        let addErrors = function (item) {
            let classes = item.getAttribute(selector.config.error).split(" ");
            let existent = item.className.split(" ");
            for (let i = 0; i < classes.length; i++) {
                if (existent.indexOf(classes[i]) == -1) {
                    item.className += " " + classes[i];
                }
            }
        }
        selector.havingErrorClassesFor(name, container).forEach(function (item) {
            addErrors(item);
        });
        selector.havingName(name, container).forEach(function (item) {
            if (item.hasAttribute(selector.config.error)) {
                addErrors(item);
            }
        })

    }
    let addErrorMessages = function (name, messages) {
        let all = selector.config.errors.all;
        let renderTemplate = function (template, message) {
            let html = template.replace(selector.config.errors.placeholder, message);
            let parser = new DOMParser();
            let node = parser.parseFromString(html, 'text/html').body.childNodes[0];
            node.removeAttribute(selector.config.template);
            node.setAttribute(selector.config.message, name)
            return node;
        }
        let addMessages = function (item) {
            let template = (item.innerHTML);

            let max = 1;
            if(selector.config.errors.all){
                max = messages.length
            }
            for (let i = 0; i < max; i++) {
                item.appendChild(renderTemplate(template, messages[i]));
            }
        };

        selector.havingErrorMessagesFor(name, container).forEach(function (item) {
            addMessages(item);
        });
    }

    let clearErrorClasses = function (name) {
        let clearErrors = function (item) {
            let classes = item.getAttribute(selector.config.error).split(" ");
            let existent = item.className.split(" ");
            let required = existent.filter(function (item) {
                return !classes.includes(item);
            });
            item.className = required.join(" ");
        }
        selector.havingErrorClassesFor(name, container).forEach(function (item) {
            clearErrors(item);
        });
        selector.havingName(name, container).forEach(function (item) {
            if (item.hasAttribute(selector.config.error)) {
                clearErrors(item);
            }
        })
    }
    let clearErrorMessages = function (name) {
        selector.errorMessagesFor(name, container).forEach(function (item) {
            item.remove();
        });
    }

    let markHavingErrors = function (name) {
        let item = selector.havingName(name, container)[0];
        item.setAttribute(selector.config.hasErrors, true);
        item.scrollIntoView({
            behavior: "smooth"
        })
    }
    let unmarkHavingErrors = function (name) {
        let item = selector.havingName(name, container)[0];
        item.removeAttribute(selector.config.hasErrors);
    }

    return {
        fill: function (errors) {
            let that = this;
            selector.formItems(container).forEach(function (item) {
                if (item.hasAttribute(selector.config.hasErrors)) {
                    that.clear(item);
                }
            });
            for (let name in errors) {
                addErrorClasses(name);
                addErrorMessages(name, errors[name]);
                markHavingErrors(name);
            }
        },
        clear: function (item) {
            let name = item.getAttribute('name');
            clearErrorMessages(name);
            clearErrorClasses(name);
            unmarkHavingErrors(name);
        }
    }


}

let success = function (container, selector, data, event) {
    let target = event.target;
    if (target.hasAttribute(selector.config.container)) {
        target.submit();
    }

}

let csr = function (options) {
    let _config = config(options);
    let _selector = selector(_config);
    let _api = api(_config);

    let submit = function (data, container, event) {

        event.stopPropagation();
        event.preventDefault();
        let fd = new FormData();
        for (let i = 0; i < data.length; i++) {
            fd.append(data[i].name, data[i].value);
        }
        _api.submit(fd).then(function (response) {
            success(container, _selector, response.data, event);
        }).catch(function (e) {
            if (_api.isValidationError(e)) {
                let handler = error(container, _selector);
                handler.fill(e.response.data.errors);
            } else {
                _config.api.forms.exception(e);
            }
        });

    }
    let containers = _selector.containers();
    containers.forEach(function (container) {
        _selector.formItems(container).forEach(function (input) {
            _config.creating(input, container);
            input.addEventListener('change', function (e) {
                error(container, _selector).clear(e.target);
            });
            input.addEventListener('keypress', function (e) {
                error(container, _selector).clear(e.target);
            })
        });
        container.onsubmit = function (e) {
            let data = new Array();
            _selector.formItems(container).forEach(function (input) {
                data.push({
                        name: input.getAttribute('name'),
                        value: input.value
                    }
                );
            });
            return submit(data, container, e);

        }
        _selector.havingSubmitOnBlur(container).forEach(function (input) {
            input.onblur = function (e) {
                submit([{
                    name: input.getAttribute('name'),
                    value: input.value
                }], container, e);
            }
        });
    });
    return {
        config: _config,
        selector: _selector,
        containers: containers
    }
}

export default {
    csr: csr
};
